import { render, staticRenderFns } from "./KemajuanMahasiswa.vue?vue&type=template&id=eb0267a6"
import script from "./KemajuanMahasiswa.vue?vue&type=script&lang=js"
export * from "./KemajuanMahasiswa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports